import { Link } from "react-router-dom";
import type { HdmgdjConfig } from "@/config/hdmgdjConfig";

interface HdmgdjDownloadHeroProps {
  config: HdmgdjConfig;
}

const HDMGDJ_JUMP =
  "/images/mascot-hero.png";

const HDMGDJ_BG =
  "/images/download-bg.jpg";

export default function HdmgdjDownloadHero({ config }: HdmgdjDownloadHeroProps) {
  const meta = [
    { icon: "ri-device-line", label: "支持平台", value: "4 大平台" },
    { icon: "ri-gift-line", label: "观看费用", value: "完全免费" },
    { icon: "ri-refresh-line", label: "剧集更新", value: "每日上新" },
  ];

  return (
    <section className="relative w-full bg-foreground-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HDMGDJ_BG}
          alt="黄豆魔改短剧下载页背景"
          title="黄豆魔改短剧-官方下载"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 hdmgdj-hero-shade" />
      </div>

      <div className="hdmgdj-container relative hdmgdj-download-pad pb-14 md:pb-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-9 px-4 rounded-full border border-background-50/20 text-background-100 text-[13px] font-label whitespace-nowrap hover:border-primary-500 hover:text-primary-300 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line text-base" />
          回到首页
        </Link>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-primary-500/15 border border-primary-500/40 text-primary-300 text-[13px] font-label">
              <i className="ri-download-cloud-2-fill text-base" />
              官方下载通道 · 安全无捆绑
            </span>
            <h1 className="mt-5 font-heading text-background-50 leading-tight text-[38px] md:text-[54px] tracking-wide">
              黄豆魔改短剧APP下载
            </h1>
            <p className="mt-5 max-w-xl text-[15px] md:text-[17px] leading-8 text-background-200">
              {"选择你的设备系统，一键获取"}
              <span className="text-primary-300 font-medium">{"黄豆魔改短剧"}</span>
              {"安装包。安装后即可免费畅看海量魔改短剧，也欢迎直接使用"}
              <span className="text-primary-300 font-medium">{"黄豆魔改短剧免费版下载"}</span>
              {"体验全新剧场。"}
            </p>

            <div className="hdmgdj-meta-panel mt-6 md:mt-7 grid grid-cols-3 max-w-md rounded-lg overflow-hidden">
              {meta.map((item) => (
                <div key={item.label} className="hdmgdj-meta-item flex flex-col px-3 sm:px-5 py-3.5">
                  <span className="hdmgdj-meta-label flex items-center gap-1.5 text-[11px] font-label">
                    <i className={`${item.icon} hdmgdj-meta-icon text-[13px]`} />
                    {item.label}
                  </span>
                  <span className="hdmgdj-meta-value mt-1.5 text-[13px] sm:text-[15px] font-label font-bold whitespace-nowrap">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative h-[300px] md:h-[380px]">
            <img
              src={HDMGDJ_JUMP}
              alt="黄豆魔改短剧吉祥物邀请下载"
              title="黄豆魔改短剧吉祥物"
              className="absolute left-1/2 -translate-x-1/2 bottom-0 w-[240px] md:w-[320px] h-auto hdmgdj-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
}